import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { useMap, useMapEvent } from 'react-leaflet';

import {
    zoomSelector, centerSelector, setMapControl, setCenter, setZoom, mapControlSelector
} from '../../../features/map/mapSlice';
import { removeDetailView } from '../../../features/assets/assetsSlice';
import { removeEventDetailView, setViewType } from '../../../features/events/eventsSlice';
import {
    addZoneDraftCoords, addMarkerDraftCoords,
    zoneDraftMapControlSelector, markerDraftMapControlSelector,
} from '../../../features/places/placesSlice';

import VehicleOverlays from '../VehicleOverlays';
import PlaceMarkerOverlay from '../PlaceMarkerOverlay';
import ZoneOverlay from '../ZoneOverlay';
import TracksOverlay from '../TracksOverlay';
import GensetTrackOverlay from '../GensetTrackOverlay';
import OsmEventMarker from './OsmEventMarker';
import OsmFindLatLngMarker from './OsmFindLatLngMarker';

import OsmZoneCreate from './OsmZoneCreate';
import OsmMarkerCreate from './OsmMarkerCreate';

const OsmChildren = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const zoom = useSelector(zoomSelector);
    const center = useSelector(centerSelector);
    const mapControl = useSelector(mapControlSelector);
    const zoneDraftMapControl = useSelector(zoneDraftMapControlSelector);
    const markerDraftMapControl = useSelector(markerDraftMapControlSelector);
    const previousViewportRef = useRef(null);

    useMapEvent('click', (e) => {
        //console.log("Map click", e);
        if (zoneDraftMapControl) {
            const point = { lat: e.latlng.lat, lng: e.latlng.lng };
            dispatch(addZoneDraftCoords(point));
        } else if (markerDraftMapControl) {
            const point = { lat: e.latlng.lat, lng: e.latlng.lng };
            dispatch(addMarkerDraftCoords(point));
        } else {
            const currCenter = map.getCenter();
            if (!['track', 'genset'].includes(mapControl)) {
                dispatch(removeDetailView());
                dispatch(setViewType('default'));
                dispatch(removeEventDetailView());
                dispatch(setMapControl('asset'));
            }
            dispatch(setCenter({ lat: currCenter.lat, lng: currCenter.lng }));
        }

    })

    useMapEvent('zoomend', () => {
        const nextZoom = map.getZoom();
        if (Number.isFinite(nextZoom)) {
            dispatch(setZoom(nextZoom));
        }
    });

    useMapEvent('moveend', () => {
        const nextCenter = map.getCenter();
        if (!nextCenter) return;
        dispatch(setCenter({ lat: nextCenter.lat, lng: nextCenter.lng }));
    });


    useEffect(() => {
        const zoomChanged = !previousViewportRef.current
            || previousViewportRef.current.zoom !== zoom;
        const centerChanged = !previousViewportRef.current
            || previousViewportRef.current.lat !== center.lat
            || previousViewportRef.current.lng !== center.lng;
        previousViewportRef.current = { lat: center.lat, lng: center.lng, zoom };

        if (zoomChanged) {
            map.setZoom(zoom);
        }
        if (centerChanged && !['track', 'genset'].includes(mapControl)) {
            map.panTo(center);
        }
    }, [map, zoom, center, mapControl])

    return (
        <div>
            <VehicleOverlays />
            <PlaceMarkerOverlay />
            <OsmEventMarker />
            <ZoneOverlay />
            <TracksOverlay />
            <GensetTrackOverlay />
            <OsmZoneCreate />
            <OsmMarkerCreate />
            <OsmFindLatLngMarker />
        </div>
    );
}

export default OsmChildren;
